import Api from '@/services/Api';

export default {
  getMeasurements(tentacle, filter) {
    return Api().get(`/measurements?tentacle=${tentacle}&filter=${filter}`);
  }
};
